import HospitalDTO from '@src/adapters/dto/hospital/HospitalDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
  name: string;
  shortCode: string;
  codeSet: string;
  regionCode: string;
}

type Result = HospitalDTO;

const options: ApiOptions = {
  method: 'post',
  urlPath: '/hospital/create',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useCreateHospitalLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateHospitalLazy;
